<template>
  <v-container class="none-fluid">
    <banner>PhD Timeline</banner>
    <div>
      <iframe
        src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1pVplt_kafcx7iB5zSgJ4fNER3ZTiaPKulfysXa6mZRU&font=Default&lang=en&initial_zoom=2"
        width="100%"
        height="750"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        frameborder="0"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";

export default {
  components: {
    Banner,
  },
};
</script>
